/**
 * Compara strings de versão Synap (`semver+build`, ex.: `1.0.0+2026-05-03.42`)
 * para decidir se a versão publicada no servidor é mais recente que a do bundle.
 */

export function splitSemverAndBuild(full: string): { semver: string; build: string } {
  const s = full.trim()
  const plus = s.indexOf('+')
  if (plus === -1) return { semver: s, build: '' }
  return { semver: s.slice(0, plus).trim(), build: s.slice(plus + 1).trim() }
}

export function parseSemverParts(semver: string): number[] {
  const core = semver.trim().split('-')[0] ?? semver
  const parts = core.split('.').map((p) => {
    const n = parseInt(p, 10)
    return Number.isFinite(n) ? n : 0
  })
  while (parts.length < 3) parts.push(0)
  return parts.slice(0, 3)
}

/** Compara sufixos `YYYY-MM-DD.N` (N numérico); fallback lexicográfico. */
export function compareBuildSuffix(a: string, b: string): number {
  if (a === b) return 0
  if (!a && b) return -1
  if (a && !b) return 1
  const ma = /^(\d{4}-\d{2}-\d{2})\.(\d+)$/.exec(a)
  const mb = /^(\d{4}-\d{2}-\d{2})\.(\d+)$/.exec(b)
  if (ma && mb) {
    if (ma[1] !== mb[1]) return ma[1] < mb[1] ? -1 : 1
    return Number(ma[2]) - Number(mb[2])
  }
  return a.localeCompare(b)
}

/**
 * `true` se `published` for estritamente mais recente que `running` (versão em execução).
 */
export function isPublishedAppVersionNewer(published: string, running: string): boolean {
  const p = splitSemverAndBuild(published)
  const r = splitSemverAndBuild(running)
  const pv = parseSemverParts(p.semver)
  const rv = parseSemverParts(r.semver)
  for (let i = 0; i < 3; i++) {
    if (pv[i]! > rv[i]!) return true
    if (pv[i]! < rv[i]!) return false
  }
  return compareBuildSuffix(p.build, r.build) > 0
}
